import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "mb-3",
  style: {"margin-top":"1.5rem"}
}
const _hoisted_2 = {
  class: "mb-3",
  style: {"margin-top":"2rem"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary mt-2"
}, "登录", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_validate_input = _resolveComponent("validate-input")!
  const _component_validate_form = _resolveComponent("validate-form")!

  return (_openBlock(), _createBlock(_component_validate_form, { onFormSubmit: _ctx.onFormSubmit }, {
    submit: _withCtx(() => [
      _hoisted_3
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_validate_input, {
          class: "form-control",
          rules: _ctx.usernameRules,
          modelValue: _ctx.usernameValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usernameValue) = $event)),
          placeholder: "请输入用户名",
          type: "text"
        }, null, 8, ["rules", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_validate_input, {
          class: "form-control",
          rules: _ctx.passwordRules,
          modelValue: _ctx.passwordValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordValue) = $event)),
          placeholder: "请输入密码",
          type: "password"
        }, null, 8, ["rules", "modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["onFormSubmit"]))
}